import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import MiniSearch, { SearchResult } from 'minisearch';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface Document {
  id: number;
  content: string;
}

@Injectable({
  providedIn: 'root',
})
export class CurrentPageSearchService {

  private index = new MiniSearch<Document>({
    fields: ['content'],
  });
  private resultSubject = new BehaviorSubject<SearchResult[]>([]);
  public readonly results = this.resultSubject.asObservable();

  private query?: string;
  private updateResultsSubject = new Subject<void>();

  public constructor() {
    this.updateResultsSubject.pipe(
      debounceTime(200),
      takeUntilDestroyed(),
    ).subscribe(() => {
      if (!this.isEmpty(this.query)) {
        this.resultSubject.next([]);
        return;
      }

      const result = this.index.search(this.query, {
        fuzzy: true,
        combineWith: 'AND',
        prefix: true,
      });
      this.resultSubject.next(result);
    });
  }

  public clear(): void {
    this.index.removeAll();
    this.updateResult();
  }

  private isEmpty(query?: string): query is string {
    return !!query;
  }

  public resultFiltered(): boolean {
    return this.isEmpty(this.query);
  }

  public setQuery(query: string): void {
    this.query = query.trim();
    this.updateResult();
  }

  public add(id: number, content: string): void {
    this.index.add({
      id,
      content,
    });
    this.updateResult();
  }


  public addAll(documents: Document[]): void {
    this.index.addAll(documents);
    this.updateResult();
  }

  private updateResult(): void {
    this.updateResultsSubject.next();
  }

}
